// Lightweight Web Audio synthesizer. No external assets.
let ctx = null;
let muted = false;

function ac() {
  if (!ctx) {
    try { ctx = new (window.AudioContext || window.webkitAudioContext)(); }
    catch { ctx = null; }
  }
  return ctx;
}

export function setMuted(v) {
  muted = !!v;
  try { localStorage.setItem("quattro_muted", muted ? "1" : "0"); } catch {}
}

export function isMuted() {
  if (typeof window === "undefined") return false;
  try {
    const v = localStorage.getItem("quattro_muted");
    if (v != null) muted = v === "1";
  } catch {}
  return muted;
}

function tone({ freq = 440, dur = 0.15, type = "sine", gain = 0.18, attack = 0.005, release = 0.08, slideTo = null } = {}) {
  if (isMuted()) return;
  const a = ac();
  if (!a) return;
  // Resume on first user gesture
  if (a.state === "suspended") a.resume().catch(() => {});
  const t0 = a.currentTime;
  const osc = a.createOscillator();
  const g = a.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (slideTo) osc.frequency.exponentialRampToValueAtTime(slideTo, t0 + dur);
  g.gain.setValueAtTime(0, t0);
  g.gain.linearRampToValueAtTime(gain, t0 + attack);
  g.gain.linearRampToValueAtTime(0.0001, t0 + dur + release);
  osc.connect(g).connect(a.destination);
  osc.start(t0);
  osc.stop(t0 + dur + release + 0.02);
}

function chord(notes, opts = {}) {
  notes.forEach((f, i) => setTimeout(() => tone({ freq: f, ...opts }), i * (opts.stagger || 70)));
}

// Public sound API — call these from UI events
export const sfx = {
  click() { tone({ freq: 720, dur: 0.05, type: "square", gain: 0.07 }); },
  draw()  { tone({ freq: 480, dur: 0.10, type: "triangle", gain: 0.12, slideTo: 760 }); },
  place() { tone({ freq: 380, dur: 0.10, type: "triangle", gain: 0.16, slideTo: 220 }); },
  stack() {
    tone({ freq: 280, dur: 0.10, type: "sawtooth", gain: 0.14 });
    setTimeout(() => tone({ freq: 520, dur: 0.10, type: "triangle", gain: 0.14 }), 60);
  },
  special() {
    chord([520, 660, 880], { dur: 0.18, type: "triangle", gain: 0.15, stagger: 55 });
  },
  turnSelf() { tone({ freq: 880, dur: 0.10, type: "sine", gain: 0.10 }); },
  win() {
    chord([523, 659, 784, 1046], { dur: 0.30, type: "triangle", gain: 0.18, stagger: 110 });
  },
  lose() {
    chord([392, 311, 247], { dur: 0.30, type: "sawtooth", gain: 0.14, stagger: 130 });
  },
};
